// extracted by mini-css-extract-plugin
module.exports = {"slideContent":"slider-content_slideContent__3C6qm","slideImg":"slider-content_slideImg__24A1V","slideDescription":"slider-content_slideDescription__1N4X8"};